import React from 'react';
import { Link } from 'react-router-dom';
import './PublicHeader.css';

const PublicHeader = ({ showTagline, rightContent }) => (
  <header className="public-header">
    <Link to="/" className="public-header__home">
      <span className="public-header__brand">Squeekit</span>
      {showTagline && (
        <span className="public-header__tagline">fast on-site window cleaning quotes</span>
      )}
    </Link>
    {rightContent && <div className="public-header__right">{rightContent}</div>}
  </header>
);

export default PublicHeader;
